import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import AddCaseDecisionTypeIndexCategoriesInteractor from "../interactors/AddCaseDecisionTypeIndexCategoriesInteractor";
import AddCaseDecisionTypeVisibilityLevelsInteractor from "../interactors/AddCaseDecisionTypeVisibilityLevelsInteractor";
import AddOrganisationCaseDecisionTypesInteractor from "../interactors/AddOrganisationCaseDecisionTypesInteractor";
import GetCaseDecisionTypeIndexCategoriesInteractor from "../interactors/GetCaseDecisionTypeIndexCategoriesInteractor";
import GetCaseDecisionTypeVisibilityLevelsInteractor from "../interactors/GetCaseDecisionTypeVisibilityLevelsInteractor";
import GetOrganisationCaseDecisionTypesInteractor from "../interactors/GetOrganisationCaseDecisionTypesInteractor";
import RemoveOrganisationCaseDecisionTypeInteractor from "../interactors/RemoveOrganisationCaseDecisionTypeInteractor";
import ShowOrganisationCaseDecisionTypesInteractor from "../interactors/ShowOrganisationCaseDecisionTypesInteractor";
import OrganisationCaseDecisionTypesPage from "../ui/pages/OrganisationCaseDecisionTypesPage";

export default class OrganisationCaseDecisionTypesArea
  extends Area
  implements IArea
{
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "addOrganisationCaseDecisionTypes",
      AddOrganisationCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "getOrganisationCaseDecisionTypes",
      GetOrganisationCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "showOrganisationCaseDecisionTypes",
      ShowOrganisationCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "addCaseDecisionTypeIndexCategories",
      AddCaseDecisionTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getCaseDecisionTypeIndexCategories",
      GetCaseDecisionTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "addCaseDecisionTypeVisibilityLevels",
      AddCaseDecisionTypeVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "getCaseDecisionTypeVisibilityLevels",
      GetCaseDecisionTypeVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "removeOrganisationCaseDecisionType",
      RemoveOrganisationCaseDecisionTypeInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes({
      path: "/organisations/:id/case-decision-type",
      page: this.createPage({
        Page: OrganisationCaseDecisionTypesPage,
        action: this.showOrganisationCaseDecisionTypesPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showOrganisationCaseDecisionTypesPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationCaseDecisionTypesInteractor>(
        "showOrganisationCaseDecisionTypes"
      )
      .execute(Number.parseInt(id, 10));
  }
}
